import {
  SBaseDisplay,
  SDate
} from '@summit/core';
import { RateFormatter } from '@summit/models';

import { EboObjectTimeLine } from '../base-classes/ebo-object-time-line';
import { Division } from './division';

export class DivisionGoal extends EboObjectTimeLine implements SBaseDisplay {
  divisionID: string;
  division: Division;
  mileageRateGoal?: number;

  constructor(jsonData: Partial<DivisionGoal>) {
    super(jsonData);
    if (jsonData && jsonData.division) {
      this.division = new Division(jsonData.division);
    }
    this.effectiveDate ??= SDate.getNormalized();
  }

  toShortString(): string {
    return `${this.effectiveDate.format('M/D/YY')} - ${RateFormatter(this.mileageRateGoal)}`;
  }
}
